export const CompleteUserInformationPage = (
  destinationLang
) => {
  return [
    {
      FormKey: 'complete-user-information-navbar-title',
      Key: 'تکيمل اطلاعات',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'complete-user-input-first-name',
      Key: 'نام',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'complete-user-input-last-name',
      Key: 'نام خانوادگی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'complete-user-information-input-name-family',
      Key: 'نام و نام خانوادگي',
      DistinitationLanguage: destinationLang,
    },

    {
      FormKey:
        'complete-user-information-input-father-name',
      Key: 'نام پدر',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'signup-input-email',
      Key: 'پست الکترونيک',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'complete-user-information-input-city-born',
      Key: 'شهر محل تولد',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'complete-user-information-input-city-live',
      Key: 'شهر محل سکونت',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'complete-user-information-input-ostan-born',
      Key: 'استان محل تولد',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'complete-user-information-input-birth-day',
      Key: 'تاريخ تولد',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-address',
      Key: 'آدرس',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'complete-user-information-input-telephone',
      Key: 'تلفن ثابت',
      DistinitationLanguage: destinationLang,
    },
  ];
};
